import React from "react";
import "./sliderLogo.styles.css";
import Slider from "react-slick";
import logo1 from "../../assets/images/home/Slider Logos/logo1.png";
import logo2 from "../../assets/images/home/Slider Logos/logo2.png";
import logo3 from "../../assets/images/home/Slider Logos/logo3.png";
import logo4 from "../../assets/images/home/Slider Logos/logo4.png";
import logo5 from "../../assets/images/home/Slider Logos/logo5.png";
import logo6 from "../../assets/images/home/Slider Logos/logo6.png";
import logo7 from "../../assets/images/home/Slider Logos/logo7.png";
import logo8 from "../../assets/images/home/Slider Logos/logo8.png";

function LogoSlider() {
  const settings = {
    infinite: true,
    autoplay: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
  };
  return (
    <div className="sliderParent">
      <Slider {...settings} className="logo-slider">
        <div className="sliderItem">
          <img src={logo1} alt="logo1" srcset="" />
        </div>
        <div className="sliderItem">
          <img src={logo2} alt="logo2" srcset="" />
        </div>
        <div className="sliderItem">
          <img src={logo3} alt="logo3" srcset="" />
        </div>
        <div className="sliderItem">
          <img src={logo4} alt="logo4" srcset="" />
        </div>
        <div className="sliderItem">
          <img src={logo5} alt="logo5" srcset="" />
        </div>
        <div className="sliderItem">
          <img src={logo6} alt="logo6" srcset="" />
        </div>
        <div className="sliderItem">
          <img src={logo7} alt="logo7" srcset="" />
        </div>
        <div className="sliderItem">
          <img src={logo8} alt="logo8" srcset="" />
        </div>
      </Slider>
    </div>
  );
}
export default LogoSlider;
